import { GenIcon } from '../helpers/IconBase.es.js';

const ArrowUpTinyFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M5.12476 15.0001L18.8748 15.0001C18.9886 15.0001 19.1002 14.9752 19.1977 14.9281C19.2951 14.881 19.3746 14.8135 19.4276 14.7329C19.4806 14.6524 19.5051 14.5617 19.4984 14.4708C19.4918 14.3799 19.4542 14.2922 19.3898 14.2171L12.5148 6.21683C12.4573 6.15001 12.3804 6.09536 12.2907 6.05761C12.201 6.01985 12.1011 6.00012 11.9998 6.00012C11.8984 6.00012 11.7985 6.01985 11.7088 6.05761C11.6191 6.09536 11.5422 6.15001 11.4848 6.21683L4.60976 14.2171C4.54534 14.2922 4.50776 14.3799 4.50109 14.4708C4.49442 14.5617 4.51891 14.6524 4.57191 14.7329C4.62492 14.8135 4.70442 14.881 4.80185 14.9281C4.89928 14.9752 5.01094 15.0001 5.12476 15.0001Z",
              fill: "#82869E"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0" },
            child: [
              {
                tag: "rect",
                attr: {
                  width: "15",
                  height: "15",
                  fill: "white",
                  transform: "translate(4.5 4.5)"
                }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};

export { ArrowUpTinyFilled };
